import { useMemo } from 'react';
import { HomeyColors } from '../../../theme/HomeyColors';
import { HomeyImages } from '../../../theme/HomeyImages';

import { useI18n } from '../../../hooks/useI18nFormatters';
import { useApi } from '../../../store/SelectedHomeyStore';

export function ManagerFlowCard(props) {
  const { i18n } = useI18n();
  const { component: Component, ...rest } = props;
  const { api } = useApi();

  const { iconUrl, iconObj, iconBackgroundColor, resourceUrl, name, isLocked } = useMemo(() => {
    const result = {
      iconUrl: HomeyImages.getIconForUri(props.ownerUri),
      iconObj: null,
      iconBackgroundColor: HomeyColors.getColorForUri(props.ownerUri),
      resourceUrl: null,
      name: i18n.messageFormatter(`manager.${props.ownerId}.name`),
      isLocked: props.card.requiresPremium === true && api.tier !== 'premium',
    };

    return result;
  }, [props.ownerUri, props.ownerId, props.card, api, i18n]);

  return (
    <Component
      {...rest}
      iconUrl={iconUrl}
      iconObj={iconObj}
      iconBackgroundColor={iconBackgroundColor}
      resourceUrl={resourceUrl}
      name={name}
      isLocked={isLocked}
    />
  );
}
